import React, { useEffect } from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
  Paper,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Divider,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PhoneIcon from "@mui/icons-material/Phone";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import TimerIcon from "@mui/icons-material/Timer";

const Dashboard2 = () => {
  const navigate = useNavigate();
  const { isAuthenticated, userData } = useSelector((state) => state.user);
  useEffect(() => {
    // Check if user is authenticated
    if (!isAuthenticated) {
      navigate("/");
    }
  }, [isAuthenticated, navigate]);
  useEffect(() => {
    if (userData && userData.testDone === true) {
      navigate("/test-completed");
    }
  }, [userData, navigate]);
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        bgcolor: "white",
      }}
    >
      <Container component="main" sx={{ flexGrow: 1, py: 4 }}>
        {/* Stepper */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            py: 1,
            position: "relative",
          }}
        >
          <Box
            sx={{
              display: "flex",
              width: "100%",
              position: "relative",
              "&::before": {
                content: '""',
                position: "absolute",
                top: "14px",
                width: "100%",
                height: "3px",
                bgcolor: "#ccc",
                zIndex: 0,
              },
            }}
          >
            <Box
              sx={{
                flex: 1,
                textAlign: "center",
                position: "relative",
                zIndex: 1,
              }}
            >
              <Box
                sx={{
                  bgcolor: "#4caf50",
                  color: "white",
                  p: "8px 14px",
                  borderRadius: "50%",
                  display: "inline-block",
                  mb: 1,
                  position: "relative",
                  zIndex: 1,
                }}
              >
                ✓
              </Box>
              <Typography variant="body2">Registration</Typography>
            </Box>
            <Box
              sx={{
                flex: 1,
                textAlign: "center",
                position: "relative",
                zIndex: 1,
              }}
            >
              <Box
                sx={{
                  bgcolor: "#e55151",
                  color: "white",
                  p: "8px 16px",
                  borderRadius: "50%",
                  display: "inline-block",
                  mb: 1,
                  position: "relative",
                  zIndex: 1,
                }}
              >
                2
              </Box>
              <Typography variant="body2">Scholarship Test</Typography>
            </Box>
            <Box
              sx={{
                flex: 1,
                textAlign: "center",
                position: "relative",
                zIndex: 1,
              }}
            >
              <Box
                sx={{
                  bgcolor: "#e55151",
                  color: "white",
                  p: "8px 16px",
                  borderRadius: "50%",
                  display: "inline-block",
                  mb: 1,
                  position: "relative",
                  zIndex: 1,
                }}
              >
                3
              </Box>
              <Typography variant="body2">
                Admission
                <br />
                (Visit Branch)
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* Banner */}
        {/* <Box
          sx={{
            bgcolor: "#3F8AC4",
            color: "white",
            p: 2,
            fontWeight: "bold",
            textAlign: "center",
            mb: 4,
          }}
        >
          Lakshya Exam - Get upto 90% scholarship*
        </Box> */}
        <Box
          sx={{
            bgcolor: "#3F8AC4",
            color: "white",
            p: 1,
            fontWeight: "bold",
            textAlign: "center",
            mb: 4,
            fontSize: "1.2rem", // increased font size
          }}
        >
        LST scholarship test - Get upto 100% scholarship
        </Box>

        {/* Exam Card */}
        <Paper
          elevation={1}
          sx={{
            borderRadius: 2,
            overflow: "hidden",
            mb: 5,
          }}
        >
          <Grid
            container
            direction={{ xs: "column", md: "row" }}
            wrap="wrap"
            sx={{ width: "100%" }}
          >
            {/* Image Section */}
            <Grid item xs={12} md="auto" sx={{ p: 0 }}>
              <Box
                component="img"
                src="/akash/images/my-hii.jpeg"
                alt="Dashboard Image"
                sx={{
                  width: { xs: "100%", md: 300 },
                  height: { xs: "auto", md: 225 },
                  display: "block",
                }}
              />
            </Grid>

            {/* Content Section */}
            <Grid
              item
              xs={12}
              md
              sx={{
                p: 3,
                whiteSpace: { xs: "normal", md: "nowrap" },
              }}
            >
              <Box>
                <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
                Hello  {userData?.name || "Student"},
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: { xs: "flex-start", md: "space-around" },
                    gap: 2,
                    alignItems: "center",
                  }}
                >
                  {/* Scholarship Test */}
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <img
                      src="/akash/images/scholarship.jpeg"
                      alt="scholarship"
                      style={{ width: 20, height: 20, marginRight: 8 }}
                    />
                    <Typography variant="body2">{userData.testInfo?.test_series_name||''}</Typography>
                  </Box>

                  {/* 25 Questions */}
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <img
                      src="/akash/images/quetion.jpeg"
                      alt="questions"
                      style={{ width: 20, height: 20, marginRight: 8 }}
                    />
                    <Typography variant="body2">{userData.testInfo?.total_questions||''} Questions</Typography>
                  </Box>

                  {/* 60 Minutes */}
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <img
                      src="/akash/images/time.jpeg"
                      alt="duration"
                      style={{ width: 20, height: 20, marginRight: 8 }}
                    />
                    <Typography variant="body2">{userData.testInfo?.time_in_mins||''} Minutes</Typography>
                  </Box>

                  {/* Start/Resume Button */}
                  <Box
                    sx={{
                      textAlign: { xs: "left", md: "center" },
                      width: { xs: "100%", md: "auto" },
                    }}
                  >
                    <Button
                      onClick={() => navigate("/test")}
                      variant="contained"
                      sx={{
                        bgcolor: "#ffc107",
                        color: "#256029",
                        fontWeight: 600,
                        mt: { xs: 2, md: 1 },
                        px: 4,
                        "&:hover": {
                          bgcolor: "#c8e6c9",
                          color: "#256029",
                        },
                      }}
                      fullWidth={
                        Boolean(userData?.testState === "resume") /* optional */
                      }
                    >
                      {userData.testState === "resume"
                        ? "Resume Test"
                        : "Start Test"}
                    </Button>
                  </Box>
                </Box>

                {/* <Typography
                  variant="caption"
                  sx={{
                    textAlign: "right",
                    mt: 2,
                    color: "#888",
                    display: "block",
                  }}
                >
                  *Terms and conditions applied
                </Typography> */}
              <Typography
  variant="caption"
  sx={{
    textAlign: { xs: "left", md: "right" }, // 👈 responsive alignment
    mt: 2,
    color: "#888",
    display: "block",
    fontSize: "10px",
  }}
>
  {/* *Terms and conditions applied */}
</Typography>



                <Box sx={{ mt: 1.25 }}>
                  <Typography variant="body2">
                    Each question carries +{userData.testInfo?.marks_per_question||''} for correct and -{userData.testInfo?.negative_marking||''} for incorrect
                    answer
                  </Typography>
                  <br></br>
                  <Typography variant="body2">
                    Need help? Call us at <strong>8503887038</strong>
                  </Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Paper>

        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Typography variant="h6" gutterBottom>
              Lakshya Advantage
            </Typography>

            <Box
              sx={{
                position: "relative",
                pt: "56.25%", // 16:9 aspect ratio
                borderRadius: 1,
                overflow: "hidden",
              }}
            >
              <iframe
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  borderRadius: "8px",
                }}
                src="https://www.youtube.com/embed/P9MzRgGXQ9Y?si=6TEhEhWKYdBeSKjw"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
            </Box>
            <Typography variant="body2" sx={{ mt: 2 }}>
              Experience the unique advantages of Lakshya Institute through this
              video.
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="h6" gutterBottom>
            Branch near you
            </Typography>
            <Paper
              elevation={3}
              sx={{
                p: 3,
                borderRadius: 1,
                mb: 3,
              }}
            >
              <Box
                sx={{
                  textAlign: "center",
                  mb: 3,
                }}
              >
                <Box
                  alt="map"
                  sx={{
                    maxHeight: 200,
                    width: "100%",
                    objectFit: "cover",
                    borderRadius: 2,
                  }}
                />
                {/* <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3153.3534585592884!2d144.9537363153855!3d-37.81621897975144!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zTGF0aXR1ZGVz!5e0!3m2!1sen!2sus!4v1614791935249!5m2!1sen!2sus"
                  style={{ border: 0, width: "100%" }}
                  allowFullScreen=""
                  loading="lazy"
                ></iframe>  */}
                 <iframe
    title="Google Map"
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3409.0397195494343!2d75.5948246!3d31.3026473!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391a5b38c0eabbaf%3A0x427cb02324b586f4!2sLakshya%20Jalandhar!5e0!3m2!1sen!2sin!4v1745408384191!5m2!1sen!2sin"
    width="100%"
    height="100%"
    style={{ border: 0 }}
    allowFullScreen
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
  ></iframe>
                {/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3409.0397195494343!2d75.5948246!3d31.3026473!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391a5b38c0eabbaf%3A0x427cb02324b586f4!2sLakshya%20Jalandhar!5e0!3m2!1sen!2sin!4v1745408384191!5m2!1sen!2sin"
                width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy"
                 referrerpolicy="no-referrer-when-downgrade"></iframe> */}
              </Box>
              <Typography variant="h6" gutterBottom>
                Jalandhar Branch
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: "primary.main", fontWeight: 600, mb: 1 }}
              >
              Opens 9 AM - Closes 7 PM

              </Typography>
              <Typography variant="body1">
                {/* Explore our facilities and meet our exceptional team in person
                at the Kakinada branch. */} 
                Explore our facilities and meet our experienced faculty at Jalandhar branch.
              </Typography>
              <Box sx={{ mt: 2 }}>
                <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                  <PhoneIcon sx={{ mr: 1, color: "primary.main" }} />
                  <a
                    href="tel:8503887038"
                    style={{ color: "black", textDecoration: "none" }}
                  >
                    8503887038
                  </a>
                </Box>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <LocationOnIcon
                  sx={{ mr: 1, color: "primary.main", mt: 0.5 }}
                />
                <Typography variant="body2">
                  SCS-8 ,Crystal Plaza, Chotti Baradari-2, Garha
                  Road,Jalandhar,144022 Punjab,India
                </Typography>
              </Box>
            </Paper>
          </Grid>
        </Grid>

        {/* FAQ Section */}
        <Box sx={{ mb: 5 }}>
          <Typography variant="h6" gutterBottom>
            FAQs
          </Typography>
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography>
                Is the Lakshya open for all Classes and Streams?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
              Lakshya offers classes for students in 7th,8th,9th,10th,11th,12th.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2a-content"
              id="panel2a-header"
            >
              <Typography>What are the exam timings?</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
              Scholarship tests are available to attempt 24/7.
              </Typography>
            </AccordionDetails>
          </Accordion>
        </Box>
      </Container>
    </Box>
  );
};

export default Dashboard2;
